import axios from "axios";
var axiosHttp = axios.create({
  // baseURL: "https://localhost:44370/api"
  baseURL: "https://crmapi.smcinsurance.com:8081/loginApiv2/api",
});

axiosHttp.interceptors.request.use(
  (req) => {
    req.headers["Content-Type"] = "application/json";

        const token = localStorage.getItem("smc-csp-token");

    if (token && token != null) {
      req.headers["Authorization"] = `Bearer ${token}`;
    }

    return req;
  },
  (err) => {
    //return Promise.reject(err);
    console.log(err);
  }
);

axiosHttp.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default axiosHttp;
